module.exports = __webpack_public_path__ + "img/arrow-up-z-a.3bef2843.svg";